import { render, staticRenderFns } from "./User_ChangePass.vue?vue&type=template&id=6a4eee06"
import script from "./User_ChangePass.vue?vue&type=script&lang=js"
export * from "./User_ChangePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports